import { Inject, Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {SourceGroup, SourceGRoupAPI} from '../..';
import {mbeConfigService} from './mbe-config.service';
import {BasicResponse, SortFilterInterface} from '@auth-suite-services/services';

@Injectable({
  providedIn: 'root',
})
export class SourceGroupService {
  private URL;
  headers: HttpHeaders;

  constructor(
    @Inject(mbeConfigService) private config,
    private httpClient: HttpClient
  ) {
    this.URL =
      config.REST_SERVER_HOST +
      config.REST_SERVER_url.find((restUrl) => restUrl.api === 'MBE').url;
    this.headers = new HttpHeaders().set('Content-Type', 'application/json');
  }

  getAllSourceGroup(
    pageIndex: number,
    pageSize: number,
    sortActive: string,
    sort: string,
    sortFilter?: SortFilterInterface
  ): Observable<SourceGRoupAPI> {
    console.log('PageIndex; PageSize; SortActive; Sort,sortFilter');
    console.log(pageIndex, pageSize, sortActive, sort, sortFilter);
    const headers = this.headers;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post<SourceGRoupAPI>(
      `${this.URL}/sgr/allsourcegroup/${pageIndex}/${pageSize}/${
        sortActive ? sortActive : 'id'
      }/${sort ? sort : 'asc'}`,
      sortFilter,
      { headers }
    );
  }

  getSourceGroup(id: number): Observable<SourceGroup> {
    console.log('SGR ID');
    console.log(id);
    const headers = this.headers;
    return this.httpClient.get<SourceGroup>(
      `${this.URL}/sgr/getsourcegroup/${id}`,
      { headers }
    );
  }

  updateSgr(sgr: SourceGroup): Observable<BasicResponse> {
    console.log('Update SGR' + JSON.stringify(sgr));
    const headers = this.headers;
    return this.httpClient.post<BasicResponse>(
      `${this.URL}/sgr/updatesourcegroup`,
      sgr,
      { headers }
    );
  }
  // Added                                          12/09/2024 PK
  createSgr(sgr: SourceGroup): Observable<BasicResponse> {
    console.log('Create SGR' + JSON.stringify(sgr));
    const headers = this.headers;
    return this.httpClient.post<BasicResponse>(
      `${this.URL}/sgr/createsourcegroup`,
      sgr,
      { headers }
    );
  }
}
